(function () {
  'use strict';

  function init() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    var content = drawer.querySelector('[data-cart-drawer-content]');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var OWN = 'X-Norelle-Drawer';
    var lastFocus = null;
    var refreshing = null;

    function setCount(n) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = n;
        el.hidden = n === 0;
      });
    }

    function refresh() {
      if (refreshing) return refreshing;
      content.classList.add('is-loading');
      refreshing = fetch(root + 'cart?view=drawer', { headers: { Accept: 'text/html' }, credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          content.innerHTML = html;
          var c = content.querySelector('[data-cart-item-count]');
          setCount(c ? Number(c.getAttribute('data-cart-item-count')) || 0 : 0);
        })
        .catch(function (e) { console.error(e); })
        .then(function () {
          content.classList.remove('is-loading');
          refreshing = null;
        });
      return refreshing;
    }

    function open() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-drawer-open');
      var closeBtn = drawer.querySelector('.cart-drawer__close');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    }

    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-drawer-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    function openFresh() {
      open();
      return refresh();
    }

    function change(key, qty) {
      content.classList.add('is-loading');
      var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
      headers[OWN] = '1';
      return fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: headers,
        credentials: 'same-origin',
        body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
      })
        .catch(function (e) { console.error(e); })
        .then(refresh);
    }

    // Header cart icon
    document.querySelectorAll('[data-cart-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openFresh();
      });
    });

    // Clicks inside the drawer
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-drawer-close]')) { close(); return; }
      var item = e.target.closest('[data-cart-item-key]');
      if (!item) return;
      var key = item.getAttribute('data-cart-item-key');
      var qtyBtn = e.target.closest('[data-cart-qty]');
      if (qtyBtn) { change(key, Number(qtyBtn.getAttribute('data-cart-qty'))); return; }
      if (e.target.closest('[data-cart-remove]')) change(key, 0);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    // Theme add-to-cart forms (product page, quick shop)
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      var action = form.getAttribute('action') || '';
      if (!form.matches('[data-product-form]') && !/\/cart\/add/.test(action)) return;
      e.preventDefault();

      var btn = e.submitter || form.querySelector('[type="submit"][name="add"], [type="submit"]');
      var label = btn && btn.querySelector('[data-add-to-cart-label]');
      var labelText = label ? label.textContent : '';
      var errorEl = form.querySelector('[data-add-to-cart-error]');
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
      if (btn) btn.disabled = true;
      if (label) label.textContent = 'Adding...';

      var headers = { Accept: 'application/json' };
      headers[OWN] = '1';
      fetch(root + 'cart/add.js', { method: 'POST', headers: headers, credentials: 'same-origin', body: new FormData(form) })
        .then(function (r) {
          if (r.ok) return openFresh();
          return r.json().catch(function () { return {}; }).then(function (data) {
            var msg = data.description || data.message || 'Could not add this item to your cart.';
            if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; }
            else { window.location.href = root + 'cart'; }
          });
        })
        .catch(function (err) { console.error(err); })
        .then(function () {
          if (btn) btn.disabled = false;
          if (label) label.textContent = labelText;
        });
    }, true);

    // Apps (bundles, upsells) that add to cart via fetch / XHR: open the drawer afterwards
    function isExternalAdd(url, headers) {
      if (!/\/cart\/add/.test(String(url || ''))) return false;
      if (!headers) return true;
      if (typeof headers.get === 'function') return !headers.get(OWN);
      return !headers[OWN];
    }

    if (window.fetch) {
      var origFetch = window.fetch;
      window.fetch = function (input, init) {
        var p = origFetch.apply(this, arguments);
        try {
          var url = typeof input === 'string' ? input : (input && input.url);
          var headers = (init && init.headers) || (input && input.headers);
          if (isExternalAdd(url, headers)) {
            p.then(function (r) { if (r && r.ok) openFresh(); }).catch(function () {});
          }
        } catch (err) { /* ignore */ }
        return p;
      };
    }

    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this._norelleAdd = /\/cart\/add/.test(String(url || ''));
      return origOpen.apply(this, arguments);
    };
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      if (this._norelleAdd) {
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) openFresh();
        });
      }
      return origSend.apply(this, arguments);
    };

    window.NorelleCartDrawer = { open: openFresh, close: close, refresh: refresh };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
